/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ClientDocumentSignedDto
} from './schema'



export const utxClientDocumentsGetDocument = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ClientDocumentSignedDto[]>> => {
    return axios.get(
      `/users/documents/${id}`,options
    );
  }


export const getUtxClientDocumentsGetDocumentQueryKey = (id: string,) => [`/users/documents/${id}`];

    
export type UtxClientDocumentsGetDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof utxClientDocumentsGetDocument>>>
export type UtxClientDocumentsGetDocumentQueryError = AxiosError<unknown>

export const useUtxClientDocumentsGetDocument = <TData = Awaited<ReturnType<typeof utxClientDocumentsGetDocument>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxClientDocumentsGetDocument>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxClientDocumentsGetDocumentQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxClientDocumentsGetDocument>>> = ({ signal }) => utxClientDocumentsGetDocument(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxClientDocumentsGetDocument>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

